import { ReactNode } from 'react';
type Props={title:string;subtitle?:ReactNode;count?:ReactNode;countLabel?:ReactNode;icon?:string};
export default function PageHeader({title,subtitle,count,countLabel,icon='bi-people'}:Props){
    return <header className="spark-page-heading"><div className="spark-page-heading-copy"><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
        {count !== undefined && <div className="spark-count"><i className={`bi ${icon}`} aria-hidden="true"/><span><strong>{count}</strong><span>{countLabel}</span></span></div>}
    </header>;
}
